export default "__VITE_ASSET__5edc90cc__"